































































































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Ref,
  Watch
} from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  alertStore,
  authUserStore,
  dataStore,
  modalErrorStore
} from '@/utils/store-accessor'
import {
  Alert,
  AlertMessage,
  DeleteReserveExpirationRequest,
  ErrorMessage,
  reserveApi,
  ReserveCancelCollection,
  ReserveCollection,
  UpdateReserveExpirationRequest
} from '@/api'
import { AlertFactory } from '@/factory'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  ReservedCollectionsTable,
  ReservedCollectionsTableItem
} from '@/components/organisms/ReservedCollectionsTable'
import { ReserveCancelCollectionsTable } from '@/components/organisms/ReserveCancelCollectionsTable'
import { ReservedCollectionButtonToggle } from '@/components/organisms/ReservedCollectionButtonToggle'
import { ModalReserveCancel } from '@/components/modals/ModalReserveCancel'
import { ModalReserve } from '@/components/modals/ModalReserve'
import { ModalInputOfReserveContactSituation } from '@/components/modals/ModalInputOfReserveContactSituation'
import {
  AlertCodeAL300018,
  AlertCodeAL300051,
  AlertCodeILC00005,
  AlertCodeILC00021,
  ReceiptPrintName,
  ReceiptPrintReserveStatusCollectionData,
  ReceiptPrintReserveStatusData,
  ReceiptPrintReserveStatusDataToJSON,
  ReserveStatus,
  ReserveType,
  UserDetailStateInfo
} from '@/types'

import { plainToDateFormat } from '@/utils'
import { CommandType } from '@/types/websocket'
import { ModalReserveSetGroupEdit } from '@/components/modals/ModalReserveSetGroupEdit'
import { ModalReserveExpirationDateBulkEdit } from '@/components/modals/ModalReserveExpirationDateBulkEdit'

export interface UserContentReservedItem {
  id: string
  reserveCollections: ReserveCollection[]
  reserveCancelCollections: ReserveCancelCollection[]
}

export const defaultUserContentReservedItem = (): UserContentReservedItem => ({
  id: '',
  reserveCollections: [],
  reserveCancelCollections: []
})

@Component({
  components: {
    ModalReserveExpirationDateBulkEdit,
    ModalReserveSetGroupEdit,
    ModalReserve,
    ModalReserveCancel,
    ModalInputOfReserveContactSituation,
    ReservedCollectionButtonToggle,
    ReserveCancelCollectionsTable,
    ReservedCollectionsTable
  }
})
export default class UserContentReserved extends ComponentVue {
  @Ref()
  reservedCollectionsTable!: ReservedCollectionsTable

  @Ref()
  reserveCancelCollectionsTable!: ReserveCancelCollectionsTable

  @Ref()
  modalReserveCancel!: ModalReserveCancel

  @Ref()
  modalReserve!: ModalReserve

  @Ref()
  modalInputOfReserveContactSituation!: ModalInputOfReserveContactSituation

  @Ref()
  modalReserveSetGroupEdit!: ModalReserveSetGroupEdit

  @Ref()
  modalReserveExpirationDateBulkEdit!: ModalReserveExpirationDateBulkEdit

  @PropSync('item', {
    type: Object,
    required: true
  })
  contentItem!: UserContentReservedItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  titleLink!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  editTable!: boolean

  activeToggleItem: string = '1'

  isAllSelect: boolean = false

  reserveCollectionsTableItems: ReservedCollectionsTableItem[] = []

  get isDisplayReserved(): boolean {
    return this.activeToggleItem === '1'
  }

  get canReserveContactSituation(): boolean {
    const checkedTableItems: ReservedCollectionsTableItem[] = this.reserveCollectionsTableItems.filter(
      value => value.isSelected
    )

    return (
      checkedTableItems.length === 1 &&
      checkedTableItems[0].reserveStatus.code === ReserveStatus.ReceiveWaiting
    )
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  @Watch('state.state')
  onChangeState(): void {
    this.reservedCollectionsTable.onSort({
      name: '',
      order: ''
    })
    this.reserveCancelCollectionsTable.onSort({
      name: '',
      order: ''
    })
  }

  @Watch('contentItem')
  initialize(): void {
    this.$nextTick(() => {
      this.isAllSelect = false
      this.reserveCollectionsTableItems = this.contentItem.reserveCollections.map(
        value => {
          return {
            isSelected: this.reserveCollectionsTableItems.some(
              item => item.isSelected && item.id === value.id
            ),
            ...value
          }
        }
      )
    })
  }

  async deleteReserveCancel(id: number) {
    this.$eventBus.emit(PAGE_LOADING_START)
    try {
      await reserveApi.deleteReserveCancel(id)
      await this.onUpdated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickAllSelect(value: boolean): void {
    this.isAllSelect = value
    this.reserveCollectionsTableItems.forEach(item => {
      item.isSelected = value
    })
  }

  openModalReserveExpirationDateBulkEdit(): void {
    const checkedTableItems: ReservedCollectionsTableItem[] = this.reserveCollectionsTableItems.filter(
      value => value.isSelected
    )
    if (checkedTableItems.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00005,
        '更新',
        '予約情報'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    if (
      checkedTableItems.every(
        item =>
          item.collectionId === 0 ||
          item.reserveStatus.code !== ReserveStatus.ReceiveWaiting
      )
    ) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00021,
        '資料割り当て済みの受取待予約'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    this.modalReserveExpirationDateBulkEdit.open({
      userId: this.contentItem.id,
      data: checkedTableItems
        .filter(
          item =>
            item.collectionId !== 0 &&
            item.reserveStatus.code === ReserveStatus.ReceiveWaiting
        )
        .map(value => {
          return {
            reserveId: value.id,
            collectionId: value.collectionId,
            revision: value.revision
          }
        }),
      onUpdated: this.onUpdated
    })
  }

  onClickReceiptPrint(): void {
    if (this.reserveCollectionsTableItems.length === 0) {
      return
    }

    const receiptPrintData: ReceiptPrintReserveStatusData = {
      customerCode: dataStore.customerCode,
      branchName: authUserStore.authUser.branchCode.name,
      userId: this.contentItem.id,
      userNoMaskDigit: dataStore.receiptInfoReserveStatusUserNoMaskDigit,
      collections: this.reserveCollectionsTableItems.map(collection => {
        const no =
          collection.collectionNo !== ''
            ? collection.collectionNo
            : `${collection.prefix}${String(collection.bibliographyId).padStart(
                10,
                '0'
              )}`
        const data: ReceiptPrintReserveStatusCollectionData = {
          displayTitle: collection.displayTitle,
          no,
          reserveDate: plainToDateFormat(
            collection.reserveRegistrationTime.substr(0, 8)
          ),
          receiveBranchName: collection.forwardingBranchCode.name,
          receivePlaceName: collection.forwardingPlaceCode.shortName,
          reserveBranchName: collection.reserveRegistrationBranchCode.name,
          reserveExpiration: plainToDateFormat(collection.reserveExpiration),
          message: collection.reserveStatusMessage,
          type: collection.specifyCollectionId ? '資料' : ''
        }
        return data
      })
    }
    this.$webSocket.sendReceiptPrintMessage({
      command: CommandType.ReceiptPrintReserveStatus,
      name: ReceiptPrintName.ReceiptPrintReserveStatus,
      data: ReceiptPrintReserveStatusDataToJSON(receiptPrintData),
      subject: `利用者番号：${this.contentItem.id}`
    })
  }

  onClickBulkDeleteReserve(): void {
    const checkedTableItems: ReservedCollectionsTableItem[] = this.reserveCollectionsTableItems.filter(
      value => value.isSelected
    )
    if (checkedTableItems.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00005,
        '削除',
        '予約情報'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    const alert: Alert = AlertFactory.create(AlertCodeAL300051)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.modalReserveCancel.open({
          reserveCancelCollections: checkedTableItems.map(value => {
            return {
              reserveId: value.id,
              revision: value.revision
            }
          }),
          onReserveCanceled: this.onUpdated
        })
      }
    })
  }

  onClickDeleteReserve(id: number): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL300051)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.modalReserveCancel.open({
          reserveCancelCollections: this.contentItem.reserveCollections
            .filter(item => item.id === id)
            .map(value => {
              return {
                reserveId: value.id,
                revision: value.revision
              }
            }),
          onReserveCanceled: this.onUpdated
        })
      }
    })
  }

  onClickDetail(bibliographyId: number): void {
    this.$nextTick(() => {
      this.modalReserve.open({
        editableUserId: this.contentItem.id,
        bibliographies: [
          {
            bibliographyRealId: bibliographyId
          }
        ],
        onChangedReserveInfo: this.onUpdated
      })
    })
  }

  onClickReserveCancelDelete(id: number): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL300018)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.deleteReserveCancel(id)
      }
    })
  }

  onClickReserveContactSituation() {
    const targetItem:
      | ReservedCollectionsTableItem
      | undefined = this.reserveCollectionsTableItems.find(
      value => value.isSelected
    )

    if (!targetItem) return

    this.modalInputOfReserveContactSituation.open({
      reserveId: targetItem.id,
      onUpdated: this.onUpdated
    })
  }

  openModalReserveSetGroupEdit(obj: {
    reserveType: ReserveType
    bibliographyId: number
    reserveSetGroupId: number
  }): void {
    this.modalReserveSetGroupEdit.open({
      reserveType: obj.reserveType,
      reserveSetGroupId: obj.reserveSetGroupId,
      bibliographyRealId: obj.bibliographyId,
      userId: this.contentItem.id,
      onRegistered: this.onUpdated,
      onReserveCanceled: this.onUpdated
    })
  }

  async onClickDeleteReserveExpiration(index: number) {
    const request: DeleteReserveExpirationRequest = {
      id: this.contentItem.reserveCollections[index].id,
      revision: this.contentItem.reserveCollections[index].revision
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.deleteReserveExpiration(request)
      await this.onUpdated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onClickUpdateReserveExpiration(index: number) {
    const request: UpdateReserveExpirationRequest = {
      id: this.contentItem.reserveCollections[index].id,
      revision: this.contentItem.reserveCollections[index].revision
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.updateReserveExpiration(request)
      await this.onUpdated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('toggled:table')
  setActiveToggleItem(value: string): void {
    this.activeToggleItem = value
  }

  @Emit('updated')
  onUpdated(): void {}
}
